import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeadCrmRoutingModule } from './leadcrm-routing.module';

import { FlexLayoutModule } from '@angular/flex-layout';
import { CustomMaterialModule } from '../custom-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ShareModule } from '../_share/share.module';
import { LeadcrmLayoutComponent } from './leadcrm-layout/leadcrm-layout.component';
import { LeadsComponent, CreateLeadDialog, UploadCsvLeadsDialog, CreateLeadTaggingDialog } from './leads/leads.component';
import { LeadcrmDashboaardComponent } from './leadcrm-dashboaard/leadcrm-dashboaard.component';
import { LeadsStatusComponent } from './leads-status/leads-status.component';
import { PapaParseModule } from 'ngx-papaparse';
import { SmsTemplateComponent, CreateSmsTemplateDialog } from './settings/sms-template/sms-template.component';
import { EmailTemplateComponent, CreateEmailTemplateDialog } from './settings/email-template/email-template.component';

@NgModule({
  declarations: [
    LeadcrmLayoutComponent,
    LeadsComponent, CreateLeadDialog, UploadCsvLeadsDialog, CreateLeadTaggingDialog,
    LeadcrmDashboaardComponent,
    LeadsStatusComponent,
    SmsTemplateComponent, CreateSmsTemplateDialog,
    EmailTemplateComponent, CreateEmailTemplateDialog
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    CustomMaterialModule,
    ReactiveFormsModule, FormsModule,
    LeadCrmRoutingModule,
    PapaParseModule,
    ShareModule,
  ],
  entryComponents: [CreateLeadDialog, UploadCsvLeadsDialog, 
    CreateLeadTaggingDialog, CreateSmsTemplateDialog, CreateEmailTemplateDialog]
})
export class LeadCrmModule { }
